var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,20H11V9h7v1.5a.5.5,0,0,0,1,0V9h.5a.49971.49971,0,0,0,.5-.5v-3a.49971.49971,0,0,0-.5-.5H13.7218A1.977,1.977,0,0,0,14,4a2.00229,2.00229,0,0,0-2-2,1.97992,1.97992,0,0,0-1.24188.44476A2.49293,2.49293,0,1,0,6.51263,5H1.5a.49971.49971,0,0,0-.5.5v3a.49971.49971,0,0,0,.5.5H2V20.5a.49971.49971,0,0,0,.5.5h9a.5.5,0,0,0,0-1ZM19,8H11V6h8ZM12,3a1,1,0,0,1,0,2H11V4A1.001,1.001,0,0,1,12,3ZM7,3.5a1.5,1.5,0,0,1,3,0V5H8.5A1.50164,1.50164,0,0,1,7,3.5ZM2,6h8V8H2ZM3,9h7V20H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,14H19.9079A1.48254,1.48254,0,0,0,20,13.5,1.50164,1.50164,0,0,0,18.5,12a1.48069,1.48069,0,0,0-.68427.17291A1.99682,1.99682,0,0,0,14,13a1.977,1.977,0,0,0,.2782,1H12.5a.49971.49971,0,0,0-.5.5v2a.49971.49971,0,0,0,.5.5H13v5.5a.49971.49971,0,0,0,.5.5h8a.49971.49971,0,0,0,.5-.5V17h.5a.49971.49971,0,0,0,.5-.5v-2A.49971.49971,0,0,0,22.5,14Zm-4-1a.5.5,0,0,1,0,1H18v-.5A.50065.50065,0,0,1,18.5,13ZM15,13a1,1,0,0,1,2,0v1H16A1.001,1.001,0,0,1,15,13Zm-2,2h4v1H13Zm1,2h3v5H14Zm7,5H18V17h3Zm1-6H18V15h4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/gift-box.ae684688552612ae22644d83328e5908.svg";
export { ForwardRef as ReactComponent };